import {
  CERTIFICATION_ANSWER_SUCCESS,
  CERTIFICATION_GET_SUCCESS,
  CERTIFICATION_GET_QUESTION_SUCCESS,
} from '../actions/certification';

export const initialState = {
  hasReceivedNullCertification: false,
  currentCertification: null,
  buffer: [],
};

export default function certificationReducer(state = initialState, action) {
  switch (action.type) {
    case CERTIFICATION_GET_SUCCESS:
      if (action.payload === null) {
        return {
          ...state,
          hasReceivedNullCertification: true,
        };
      }
      return {
        ...state,
        currentCertification: state.currentCertification
          ? state.currentCertification
          : action.payload,
        buffer: state.currentCertification ? [...state.buffer, action.payload] : state.buffer,
      };
    // v5 only (details in store\actions\certification.js)
    case CERTIFICATION_GET_QUESTION_SUCCESS:
      if (action.payload === null) {
        return {
          ...state,
          hasReceivedNullCertification: true,
        };
      }
      return {
        ...state,
        currentCertification: action.payload,
      };
    case CERTIFICATION_ANSWER_SUCCESS: {
      const bufferCopy = state.buffer.slice(0);
      return {
        ...state,
        currentCertification: bufferCopy.length ? bufferCopy[0] : null,
        buffer: bufferCopy.slice(1),
      };
    }
    default:
      return state;
  }
}
